import { memo } from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

/**
 * Mobile sidebar menu component
 */
const SidebarMenu = ({ anchorEl, open, onClose }) => {
  const { t } = useTranslation("common");

  // Navigation items for the sidebar menu
  const menuItems = [
    { path: "/", label: t("common.home") },
    { path: "/device", label: t("common.devices") },
    { path: "/dashboard", label: t("common.dashboards") },
    { path: "/action", label: t("common.actions") },
    { path: "/report", label: t("common.reports") },
    { path: "/asset", label: t("common.assets") },
    { path: "/geofence", label: t("common.geofences") },
    { path: "/organisation", label: t("common.organisations") },
    { path: "/contact", label: t("common.contacts") },
    { path: "/account", label: t("common.account") },
  ];

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {menuItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={onClose}
        >
          <MenuItem>
            <Typography variant="body1">{item.label}</Typography>
          </MenuItem>
        </Link>
      ))}
    </Menu>
  );
};

SidebarMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default memo(SidebarMenu);
